<div
  *ngIf="visible"
  class="scope-tooltip change-request-tooltip">
  <ng-container [ngSwitch]="changeRequestStatus">
    <!-- DRAFT -->
    <span
      class="inner-tooltip"
      *ngSwitchCase="ChangeRequestStatus.DRAFT">
      <button
        type="button"
        (click)="submitDraft()">
        Submit
      </button>
    </span>

    <!-- CLIENT_APPROVED -->
    <span
      class="inner-tooltip"
      *ngSwitchCase="ChangeRequestStatus.CLIENT_APPROVED">
      <span class="inner-tooltip">
        <button
          type="button"
          (click)="backToDraft()">
          Back to draft
        </button>
      </span>
      <span class="inner-tooltip">
        <button
          type="button"
          (click)="dismiss()">
          Dismiss
        </button>
      </span>
      <span class="inner-tooltip">
        <button
          type="button"
          (click)="mergeToScope()">
          Merge to Scope
        </button>
      </span>
    </span>
  </ng-container>
</div>
